import type { CSSProperties } from 'react';

/**
 * Returns a style object that sets the `--cc` custom property used by the
 * per-category color mechanism (cc-chip, cc-badge, cc-hover-border, etc.).
 */
export const ccVar = (color: string): CSSProperties =>
  ({ ['--cc' as string]: color }) as CSSProperties;

/** Relative brightness (0-1) of a 6-digit hex, no leading `#`. */
export const brightness = (hex: string): number => {
  const n = parseInt(hex, 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
};

/**
 * Whether a brand colour sits too close to black or white to be painted as
 * itself. Those marks vanish into one theme or the other - Cursor's and
 * GitHub's black on the dark theme, a near-white mark on the light one - so
 * every surface that paints brand colour has to fall back to the theme
 * foreground for them.
 *
 * Shared by `BrandIcon` and `AgentGlyph`: the threshold is a judgement call and
 * two copies of it would drift.
 */
export const isMonoHex = (hex: string): boolean => {
  const b = brightness(hex);
  return b < 0.18 || b > 0.82;
};
